module.exports = __webpack_public_path__ + "img/default-user.1fbd28a5.png";